import { Injectable } from "@angular/core";
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { HttpClient } from "@angular/common/http";

export const RELEASE_REPORT_URI = '/cfr-service/releaseReport/release';

@Injectable({
    providedIn: 'root'
})

export class ReleaseReportService {
    constructor(
            private http: HttpClient) 
        { }

    releaseReport(payload): Observable<any>{
        return this.http.post<any>(`${environment.serviceUrl}${RELEASE_REPORT_URI}`, payload);
    }
}
